import { render, staticRenderFns } from "./ModalListarComprobantes.vue?vue&type=template&id=06c17419&scoped=true&"
import script from "./ModalListarComprobantes.vue?vue&type=script&lang=js&"
export * from "./ModalListarComprobantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c17419",
  null
  
)

export default component.exports